import React from 'react';
import { faClone } from '@fortawesome/pro-regular-svg-icons';
import SIcon from './SIcon';

const Clone = props => <SIcon {...props} icon={faClone} fa />;

export default Clone;
